import { Input } from "antd";
import React, { useState } from "react";
import CreatableSelect from 'react-select/creatable';

const NonCostCard = (props) => {
  const {index, item, onAddOptions, removeFromOption, field} = props;

    const [inputValue, setInputValue] = useState('');
  const [value, setValue] = useState([]);
  const createOption = (label) => ({
    label,
    value: label,
  });

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        // setValue((prev) => [...prev, createOption(inputValue)]);
        onAddOptions(index, inputValue, field);
        setInputValue('');
        event.preventDefault();
    default: return null;
    }
}
    const components = {
        DropdownIndicator: null,
      };
    return <div className="non_cost">
        <label>Options (Press enter after each option)</label>
        <CreatableSelect
    //   components={components}
      inputValue={inputValue}
      isClearable
      isMulti
      menuIsOpen={false}
      // onChange={(newValue) => setValue(newValue)}
      onChange={(newValue) => removeFromOption(index,newValue)}
      onInputChange={(newValue) => setInputValue(newValue)}
      onKeyDown={handleKeyDown}
      className="create_dd"
      placeholder="Type something and press enter..."
      value={JSON.parse(item?.options)?.map((opt)=>({label:opt, value:opt}))}
      // value={value}
    />
    </div>
};
export default NonCostCard;